import clsx from 'clsx';
import Txt from 'components/atoms/Txt/Txt';
import { useRouter } from 'next/router';
import { ReactElement, useMemo } from 'react';

export type Props = {
  amount: number;
  currency: string;
  className?: string;
  component?: 'span' | 'div' | 'p';
  numberClassName?: string;
  currencyClassName?: string;
  options?: Intl.NumberFormatOptions;
};

export default function Currency({
  amount,
  currency,
  className,
  component = 'span',
  numberClassName,
  currencyClassName,
  options,
}: Props): ReactElement {
  const { locale } = useRouter();
  const formattedParts = useMemo(() => {
    if (currency === 'POINTS') {
      return [
        ...new Intl.NumberFormat(locale, {
          currencyDisplay: 'narrowSymbol',
          // @ts-ignore - This is not in the types, but it is in the spec
          numberingSystem: 'latn',
          ...options,
        }).formatToParts(amount),
        {
          type: 'currency',
          value: 'LP',
        },
      ];
    } else {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        // @ts-ignore - This is not in the types, but it is in the spec
        numberingSystem: 'latn',
        ...options,
      }).formatToParts(amount);
    }
  }, [amount, currency, locale, options]);

  return (
    <Txt className={clsx(className)} component={component} skipTranslation>
      {formattedParts.map(({ type, value }, index) => {
        if (type === 'currency') {
          if (value === 'US$' || value === '$US') {
            value = '$';
          }
          return (
            <span key={index} className={clsx(currencyClassName)}>
              {value}
            </span>
          );
        }
        return (
          <span key={index} className={clsx(numberClassName)}>
            {value}
          </span>
        );
      })}
    </Txt>
  );
}
